import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setDealType } from './store/deal_type/actions';

import { Nav, NavItem } from 'react-bootstrap';

export function PlaybookDealTypes({ dealType, dealTypeOptions, setDealType }) {
  return (
    <Nav
      activeKey={dealType}
      bsStyle="pills"
      className="muted"
      onSelect={setDealType}
    >
      {dealTypeOptions.map(dealType => (
        <NavItem eventKey={dealType.value} key={dealType.value}>
          {dealType.label}
        </NavItem>
      ))}
    </Nav>
  );
}


PlaybookDealTypes.propTypes = {
  dealType: PropTypes.string.isRequired,
  dealTypeOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  setDealType: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  dealType: state.dealType,
  dealTypeOptions: state.dealTypeOptions,
});

const mapDispatchToProps = {
  setDealType,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlaybookDealTypes);
